<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
@import '@/themes/default/variables.scss';

body {
  overflow: hidden;
}

.btn-primary {
  color: $white;
  &:hover {
    color: $white;
  }
}
.outline-primary {
  &:hover {
    color: $white;
  }
}

.idx-bold {
  font-weight: bold;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue